import React, { useState } from "react"
import { Navigate, Outlet } from "react-router-dom"

const Authmiddleware = ({
  isAuthProtected,
}) => {

  const [authenticated, setAuthenticated] = useState(true)
  return authenticated && isAuthProtected ? 
    <Outlet /> : <Navigate to={{ pathname: "/login" }} />
}

export default Authmiddleware;
